import React, {useEffect, useRef, useState} from 'react';
import personIcon from '../../../imgs/post.svg';
import backIcon from '../../../imgs/backIcon.svg';
import departmentIcon from '../../../imgs/departmenticon.svg';
import HomeSidebar from '../homeSidebar/homeSidebar';
import {EmojiIcon, PlaneIcon, TipIcon, XIcon} from '../SvgIcons/SvgIcons';
import SentMsg from './SentMsg';
import ReceivedMsg from './ReceivedMsg';
import {useHistory} from 'react-router-dom';
import {gql, useLazyQuery, useMutation} from '@apollo/client';
import {GET_MESSAGES} from '../../../graphql/query/messages';
import {useSelector} from 'react-redux';
import {CREATE_MESSAGE} from '../../../graphql/mutations/messages';
import {Spin} from 'antd';
import {withSocket} from '../../../utils/withSocket';
import { removeDuplicates } from '../../../utils/helpers/reusableFuntions';

const Inbox = ({socket}) => {
  const [messagesData, setMessagesData] = useState([]);
  const [message, setMessage] = useState('');
  const [loader, setLoader] = useState(false);
  const loading = useRef(null);
  const [isNextRequest, setIsNextRequest] = useState(true);
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1);
  const [start, setStart] = useState(0);
  const [limit] = useState(10);

  useEffect(() => {
    var options = {
      root: null,
      rootMargin: '20px',
      threshold: 1.0,
    };
    // initialize IntersectionObserver
    // and attaching to Load More div
    const observer = new IntersectionObserver(handleObserver, options);
    if (loading.current) {
      observer.observe(loading.current);
    }
  }, []);

  const handleObserver = (entities) => {
    const target = entities[0];
    if (target.isIntersecting) {
      setPage((page) => page + 1);
    }
  };

  useEffect(() => {
    if (isNextRequest) {
      setStart(start + 10);
      setIsNextRequest(false);
      getMessages({
        variables: {
          channelId: channelData?.offers?.channelId?.id,
          start: start + 10,
          limit: limit,
        },
      });
    }
  }, [page]);

  const history = useHistory();

  const {
    location: {
      state: {channelData},
    },
  } = history;

  const userProfile = useSelector((state) => state.strapiRes);

  const [getMessages, {data: myMessageList}] = useLazyQuery(
    gql(GET_MESSAGES),
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  useEffect(() => {
    getMessages({
      variables: {
        channelId: channelData?.offers?.channelId?.id,
        start: start,
        limit: limit,
      },
    });
  }, [channelData?.offers?.channelId?.id]);

  useEffect(() => {
    if (myMessageList && myMessageList.messages) {
      // debugger
      setIsNextRequest(true);
      if (myMessageList.messages.length) {
        if (myMessageList.messages.length < 10) setHasMore(false);
        let mergeMessages = [...messagesData, ...myMessageList.messages];
        mergeMessages.filter((obj) => {
          return !obj.hasOwnProperty('id');
        });
        let result = removeDuplicates(mergeMessages);
        // console.log(mergeMessages, 'merge')
        const data = result.sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at),
        );
        setMessagesData(data);
      } else {
        setHasMore(false);
      }
    }
  }, [myMessageList]);

  const [createMessage] = useMutation(gql(CREATE_MESSAGE));

  const handleMessage = () => {
    setMessage('');
    if (message && userProfile?.id && channelData?.offers?.channelId?.id) {
      setLoader(true);
      createMessage({
        variables: {
          message: message,
          user: userProfile?.id,
          channelId: channelData?.offers?.channelId?.id,
        },
      }).then((res) => {
        setLoader(false);
      });
    }
  };

  useEffect(() => {
    socket.on(`message-refetch-${channelData?.offers?.channelId?.id}`, () => {
      setStart(0);
      setMessagesData([]);
      getMessages({
        variables: {
          channelId: channelData?.offers?.channelId?.id,
          start: 0,
          limit: 10,
        },
      });
    });
    return () => {
      socket.off(`message-refetch-${channelData?.offers?.channelId?.id}`);
    };
  }, []);

  return (
    <div className="home-container">
      <HomeSidebar></HomeSidebar>
      <div className="home-content chat-content">
        <div className="chat-top">
          <button className="back-icon" onClick={() => history.goBack()}>
            <img src={backIcon} alt="backIcon" />
            Back
          </button>
          <div className="space-between">
            <h2 className="heading">
              @{channelData.offers?.introPerson?.firstName}
              {channelData.offers?.introPerson?.lastName}
            </h2>
            <h2 className="small-heading">
              {channelData?.offers?.bountyId?.bountyType === 'company' ? (
                <img src={departmentIcon} alt="" className="mr-1" />
              ) : (
                <img src={personIcon} alt="personIcon" className="mr-1" />
              )}
              {channelData.offers?.bountyId?.bountyType === 'company'
                ? channelData?.offers?.bountyId?.company
                : channelData?.offers?.bountyId?.fullName}
            </h2>
          </div>
        </div>
        <div className="inbox-container">
          <div className="tip-wrapper">
            <TipIcon />
            <p>
              Mark as complete after the introduction has actually happened.
            </p>
            <XIcon />
          </div>
          <div className="messages-list">
            {messagesData && messagesData.length ? (
              messagesData.map((message, index) => {
                return (
                  <>
                    {message.user.id === userProfile.id ? (
                      <SentMsg message={message} />
                    ) : (
                      <ReceivedMsg message={message} />
                    )}
                  </>
                );
              })
            ) : (
              <></>
            )}
            {hasMore && (
              <div className="loading" ref={loading}>
                <Spin spinning={loading} className="spin-loading" />
              </div>
            )}
          </div>
          <div className="message-sender-wrap">
            <div className="emoji-box">
              <EmojiIcon />
            </div>
            <div className="msg-input">
              <input
                type="text"
                placeholder="Reply something"
                name="message"
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              />
              <button className="sent-btn" onClick={handleMessage}>
                <PlaneIcon />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withSocket(Inbox);
